import Tools from "./components/tools";
import { BoardSelectionProvider } from "./components/BoardSelectionContext";
import SidebarContainer from "./refractCommon/components/SidebarContainer";
import Pro from "./components/pro";
import { useState } from "react";
import config from "./config";
import { devButtons } from "./devButtons";
import { logAnalytic, useIsPro } from "./refractCommon/utils/useFirestore";

export type UserData = { miroUserId?: string, isPro?: boolean }

function Sidebar() {
  // const [isPro, setIsPro] = useState<boolean | undefined>(undefined);
  const { isPro, setIsPro } = useIsPro();

  const [environment, setEnvironment] = useState<string>(config.environment);
  const [uatToggleState, setUatToggleState] = useState<boolean>(false);
  const [selectedToolset, _setSelectedToolset] = useState({
    toolset_name: "None",
  });

  const setSelectedToolset = (toolSet: any) => {
    _setSelectedToolset(toolSet)
    logAnalytic("selectToolset", { name: toolSet.toolset_name });
  }

  const [toolSelected, setToolSelected] = useState(false);

  return (
    <>
      <SidebarContainer

        header={
          <div
            id="grid"
            className="cs1 ce12 grid "
            style={{
              display: !toolSelected ? "none" : "block",
            }}
          >
            <div className="grid breadcrumb">
              <div
                className="grid cs1 ce12 back-button-container"
                onClick={() => {
                  // reset the tool container's scroll height.
                  let scrollDiv = document.getElementById("sidebar-content");
                  if (scrollDiv) {
                    scrollDiv.scrollTop = 0;
                    setSelectedToolset({
                      toolset_name: "None",
                    });
                    setToolSelected(false);
                  }
                }}
              >
                <svg
                  id="back-button"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1213 16.7071C14.7308 17.0976 14.0976 17.0976 13.7071 16.7071L8.99997 12L13.7071 7.29291C14.0976 6.90238 14.7308 6.90238 15.1213 7.29291C15.5118 7.68343 15.5118 8.3166 15.1213 8.70712L11.8284 12L15.1213 15.2929C15.5118 15.6834 15.5118 16.3166 15.1213 16.7071Z"
                    className="back-button-svg icon m2 cs1 "
                  />
                </svg>

                <p className="p-medium cs2 ce12 h4   mb-0 mt-0">
                  {selectedToolset.toolset_name}
                </p>
              </div>
            </div>
          </div>
        }

        body={<>
          <BoardSelectionProvider>
            <Tools
              isPro={isPro}
              environment={environment}
              selectedToolset={selectedToolset}
              setSelectedToolset={setSelectedToolset}
              toolSelected={toolSelected}
              setToolSelected={setToolSelected}
            />
          </BoardSelectionProvider>
          <div style={{
            opacity: '0.2',
            fontSize: 'xx-small',
            textAlign: 'right'
          }}>{config.version} {config.environment}</div>
        </>
        }

        footer={
          <div className="footer grid">
            <button
              type="button"
              className="button-secondary button button-small mb-0 mt-0 pt-0 pb-0 cs1 ce7 fix-stupid-button "
              onClick={() =>
                window.open("https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs", "_blank")
              }>
              Request tool or Report issue
            </button>

            <Pro
              isPro={isPro}
            //setIsPro={setIsPro}
            />
            {config.features.proToggle
              && setIsPro &&
              (
                <div className="cs1 ce2">
                  <label className="toggle mb-0">
                    <input
                      type="checkbox"
                      tabIndex={0}
                      checked={isPro === true}
                      onChange={() => {
                        setIsPro(!isPro);
                      }}
                    />
                    <span>Pro</span>
                  </label>
                </div>
              )}
            {config.features.uatToggle && (
              <div className="cs4 ce5">
                <label className="toggle  mb-0">
                  <input
                    type="checkbox"
                    tabIndex={0}
                    onChange={() => {
                      if (uatToggleState === false) {
                        setUatToggleState(true);
                        setEnvironment("beta");
                      } else {
                        setUatToggleState(false);
                        setEnvironment("dev");
                      }
                    }}
                  />
                  <span>Beta</span>
                </label>
              </div>
            )}
            {devButtons}
          </div>
        } />
    </>
  );
}

export default Sidebar;
